export default __webpack_public_path__ + "static/media/rpilog.a930cfa8.mp4";